module.exports = __webpack_public_path__ + "img/tree-4.0b321ab4.png";